import type { ReactNode } from 'react';
import type { PublicUser } from '@clanfire/shared';
import { nameStyle } from '@/lib/profileStyle';
import { cn } from '@/lib/utils';

type Source = Pick<PublicUser, 'nameFont' | 'nameEffect' | 'nameColor' | 'nameColor2' | 'accentColor'>;

/** A display name in the user's chosen font/effect (falls back to e.g. their role colour). */
export function StyledName({ user, fallbackColor, className, children }: { user: Source | null | undefined; fallbackColor?: string; className?: string; children: ReactNode }) {
  const { style, className: effectClass } = nameStyle(user, fallbackColor);
  return (
    <span className={cn(effectClass, className)} style={style}>
      {children}
    </span>
  );
}
